<template>
  <div class="customer-item">
    <div class="customer-item-tile">
      <div class="customer-name">
        <span class="title" v-html="fullNameHighlighted"></span>
      </div>
      <div class="customer-email">
        <svg class="o-icon fill-black"><use xlink:href="#email-outline"></use></svg>
        <span class="text" v-html="emailHighlighted"></span>
      </div>
      <div class="customer-phone">
        <span class="text">{{phoneNumber}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import find from 'lodash/find'

export default {
  name: 'CustomerTile',
  props: {
    customer: {
      type: Object,
      required: true
    },
    inputText: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    fullNameHighlighted () {
      if (this.customer) {
        let fullName = this.customer.firstname + ' ' + this.customer.lastname
        return fullName.replace(new RegExp(this.inputText, 'i'), `<b>${this.inputText}</b>`)
      }
    },
    emailHighlighted () {
      if (this.customer) {
        return this.customer.email.replace(new RegExp(this.inputText, 'g'), `<b>${this.inputText}</b>`)
      }
    },
    phoneNumber () {
      if (this.customer && this.customer.default_billing) {
        let address = find(this.customer.addresses, { id: parseInt(this.customer.default_billing) })
        if (address) {
          return address.telephone
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  }
}
</script>
